var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "task-list-view" } }, [
    _c(
      "div",
      { staticClass: "kanban-task-table" },
      [
        _c("supsis-table", {
          attrs: {
            columns: _vm.columns,
            rows: _vm.filterTasks,
            "bottom-pagination": true,
            "pagination-cursor": _vm.paginationCursor,
            options: _vm.tableOptions,
          },
          on: {
            "cursor-changed": function (cursor) {
              return (_vm.paginationCursor = cursor)
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }